import React from "react";

/**
 * Original tactical patch/badge used as default branding placeholder.
 * Hexagonal shield with central star + chevrons. 100% original design.
 */
export default function TacticalBadge({ size = 44, label = "BOYS", sub = "OPS" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={`${label} ${sub}`}
    >
      {/* Hex shield outer */}
      <polygon
        points="50,4 90,26 90,74 50,96 10,74 10,26"
        fill="#141812"
        stroke="#b08d57"
        strokeWidth="2.5"
      />
      {/* Hex shield inner ring */}
      <polygon
        points="50,12 82,30 82,70 50,88 18,70 18,30"
        fill="none"
        stroke="#3d4527"
        strokeWidth="1"
      />
      {/* Star */}
      <polygon
        points="50,22 54.5,34 67,34 57,42 60.5,54 50,46.5 39.5,54 43,42 33,34 45.5,34"
        fill="#b08d57"
      />
      {/* Three rank dots above star */}
      <circle cx="42" cy="18" r="1.6" fill="#b08d57" />
      <circle cx="50" cy="17" r="1.6" fill="#b08d57" />
      <circle cx="58" cy="18" r="1.6" fill="#b08d57" />
      {/* Chevron below star */}
      <polyline
        points="34,62 50,70 66,62"
        fill="none"
        stroke="#7d9947"
        strokeWidth="2.2"
        strokeLinecap="square"
      />
      {/* Banner ribbon */}
      <rect x="22" y="75" width="56" height="10" fill="#0a0d0a" stroke="#b08d57" strokeWidth="0.8" />
      <text
        x="50"
        y="82.4"
        textAnchor="middle"
        fill="#d4a574"
        fontFamily="'JetBrains Mono', monospace"
        fontSize="7"
        fontWeight="700"
        letterSpacing="1.5"
      >
        {(label + " " + sub).slice(0, 10)}
      </text>
    </svg>
  );
}
